module.exports = __webpack_public_path__ + "media/images/icons/outlined/gif-e79415f10050cb98c5479c7aabe81d8c.svg";